(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
(() => {
  if(customElements.get('grim-halloween-live')) return;
  class GrimHalloweenLive extends HTMLElement {
    connectedCallback() {
      if(this._mounted)return;
      this._mounted=true;
      this._inView=true;
      this.dataset.ghlMotion='on';
      this._start=Date.parse(this.dataset.start||'');
      this._ready=()=>{
        if(!this.querySelector('[data-ghl-digit]'))return;
        if(this._childrenObserver){this._childrenObserver.disconnect();this._childrenObserver=null;}
        this._digits=[...this.querySelectorAll('[data-ghl-digit]')];
        this._readout=this.querySelector('[data-ghl-readout]');
        this._visibility=()=>this.syncClock();
        document.addEventListener('visibilitychange',this._visibility);
        this._intersection=new IntersectionObserver(entries=>{this._inView=entries[0].isIntersecting;this.syncClock();},{rootMargin:'150px'});
        this._intersection.observe(this);
        this.tick();this.syncClock();
      };
      if(this.querySelector('[data-ghl-digit]'))this._ready();
      else{this._childrenObserver=new MutationObserver(this._ready);this._childrenObserver.observe(this,{childList:true,subtree:true});}
    }
    syncClock(){
      clearInterval(this._clock);this._clock=null;
      const visible=!document.hidden&&this._inView;
      this.dataset.ghlVisible=String(visible);
      if(visible){this.tick();if(this.dataset.ghlState==='scheduled')this._clock=setInterval(()=>this.tick(),1000);}
    }
    tick(){
      const valid=Number.isFinite(this._start);
      const total=valid?Math.max(0,Math.ceil((this._start-Date.now())/1000)):0;
      const parts={days:Math.floor(total/86400),hours:Math.floor(total%86400/3600),minutes:Math.floor(total%3600/60),seconds:total%60};
      for(const node of this._digits||[]){const value=valid?String(parts[node.dataset.ghlDigit]).padStart(2,'0'):'—';if(node.textContent!==value)node.textContent=value;}
      this.dataset.ghlState=!valid?'invalid':total>0?'scheduled':'started';
      const accessibleLabel=!valid?'Halloween, yüzde 30’a varan indirim. Başlangıç tarihi güncelleniyor.':total>0?'Halloween, yüzde 30’a varan indirim. 31 Ekim’de başlıyor.':'Halloween fırsatları başladı. Yüzde 30’a varan indirim.';
      if(this._label!==accessibleLabel){this.querySelectorAll('.ghl-desktop,.ghl-mobile').forEach(svg=>svg.setAttribute('aria-label',accessibleLabel));this._label=accessibleLabel;}
      if(this._readout)this._readout.textContent=!valid?'Başlangıç tarihi güncelleniyor':total>0?`${parts.days} gün, ${parts.hours} saat, ${parts.minutes} dakika, ${parts.seconds} saniye`:'Halloween fırsatları başladı.';
      if(total===0){clearInterval(this._clock);this._clock=null;}
    }
    disconnectedCallback(){
      clearInterval(this._clock);this._clock=null;
      this._intersection?.disconnect();this._childrenObserver?.disconnect();
      if(this._visibility)document.removeEventListener('visibilitychange',this._visibility);
      this._mounted=false;
    }
  }
  customElements.define('grim-halloween-live',GrimHalloweenLive);
})();


  } catch(e) { console.error(e); }
})();
})();
